import React from "react";
import { Grid, Typography, Box, Button, Container } from "@mui/material";
import girl from './Images/cup.avif'
import blaxk from './Images/good.jpg'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
const Wintercollection = () => {
  const navigate =useNavigate();
  return (
    <React.Fragment>
      <Container>
   <Typography sx={{ display: "flex", mt: { lg: 15, xs: 5, md: 10 }, borderBottom: "4px solid black", width: {lg:"40%",md:"50%"},borderBottomLeftRadius:20 }}>
  <Typography sx={{ fontSize: "2.5rem", color: "#022a6b" }}>
    Winter
  </Typography>
  <Typography sx={{ fontSize: "1.5rem", marginTop: 2.2, marginLeft: 1 }}>
    Collection
  </Typography>
</Typography>


        <Typography sx={{ mt: 3, fontSize: "1.1rem"}}>
          {" "}
          We consider your look and comfort on scorching weather.
        </Typography>
        <Box >
          <Grid container spacing={10}>
          <Grid item lg={6} md={6} xs={12}>
              <Typography sx={{ mt: { lg: 5, md: 5 } }}>
                We provide the largest clothing collection for any season. You
                can choose trendy or classy design according to your
                preferences. Our services are super fast and we update within 24
                hours.
              </Typography>
              <Box sx={{ position: "relative" }}>
                <Box
                  component="img"
                  boxShadow={24}
                  src={girl}
                  sx={{
                    borderRadius: "25px",
                    mt: 4,
                    
                    maxWidth: { lg: 300, md: 300, xs: 300 },
                    position: "absolute",
                    zIndex: 1,borderLeft:"10px solid #1a193a",
                    cursor: "pointer", ":hover": {
                      transition: "0.3s",
                      transform: "scale(1.05)",
                    },
                  }}
                />
                <Box
                  component="img"
                  boxShadow={24}
                  src={blaxk}
                  sx={{
                    
                    borderRadius: "35px",
                    mt: {lg:18,md:18,xs:25},ml: { lg: 20, md: 20,xs:5 },
                    maxWidth: { lg: 280, md: 280, xs: 280 },
                    position: "absolute",
                    zIndex: 2,borderRight:"10px solid #1a193a",
                    cursor: "pointer", ":hover": {
                      transition: "0.3s",
                      transform: "scale(1.05)",
                    },
                  }}
                />
              </Box>
            </Grid>
            <Grid item lg={6} xs={12} md={6}>
            <Button
            onClick={()=>navigate("/wintercollection")}
            varient="contained"
            sx={{
              marginLeft: "auto",
              display: "flex",
              boxShadow: 24,
              borderRadius: 5,

              fontSize: "1rem",

              padding: "8px 20px 8px 20px",
              cursor: "pointer",
              marginTop: {lg:8,xs:45,md:10},
              marginRight: 3.5,
              bgcolor: "white",
              color: "#022a6b",

              "&:hover": {
                transform: "scale(1.05)",
                transition: "0.2s",
                bgcolor: "#022a6b",
                color: "white",
              },
            }}
          >
            Explore <ArrowForwardIcon />
          </Button>
          <Typography sx={{ mt: { lg: 10, md: 5 ,xs:5} }}>
                We provide the largest clothing collection for any season. You
                can choose trendy or classy design according to your
                preferences. Our services are super fast and we update within 24
                hours.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default Wintercollection;
